import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueuesManageViewEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const queuesManageViewEntryPoint: EntryPoint<QueuesManageViewEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<QueuesManageViewEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-csm-queues-manage-view", jiraSpaEntry: "async-servicedesk-csm-queues-manage-view" */ './ExportedDefault.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
